// @ts-nocheck
import Gallery from "../components/Gallery.js";
import { cats, catsRowConfig } from "../components/galleryImages.js";

function Cats() {
	return (
		<div className="cats-container">
			<Gallery galleryImages={cats} type={"cats"} rowConfig={catsRowConfig}></Gallery>
		</div>
	);
}

export default Cats;
